import { ChakraComponents as CC } from '@Modules/core/lib/chakra';

export interface IUsersSupervisionDatatable {
  username: string;
  state: string;
  createdAt: string;
  lockAt: string;
  expireAt: string;
  profile: string;
  outSessionLimit: string;
}

const columns = (handleEdit: any, handleDel: any) => [
  {
    id: 'username',
    header: "Nom d'utilisateur",
    accessorKey: 'username',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'state',
    header: 'Etat',
    accessorKey: 'state',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'createdAt',
    header: 'Créé le',
    accessorKey: 'createdAt',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'lockAt',
    header: 'Vérouillé le',
    accessorKey: 'lockAt',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'expireAt',
    header: 'Expiré le',
    accessorKey: 'expireAt',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'profile',
    header: 'Profile',
    accessorKey: 'profile',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'outSessionLimit',
    header: 'Depas Lim Session',
    accessorKey: 'outSessionLimit',
    cell: (ctx: any) => {
      const row = ctx.row.origial;
      return (
        <CC.Box>
          <CC.RadioGroup defaultValue={ctx.getValue()}>
            <CC.Stack direction="row" spacing={2}>
              <CC.Radio value="yes">Oui</CC.Radio>
              <CC.Radio value="no">Non</CC.Radio>
            </CC.Stack>
          </CC.RadioGroup>
        </CC.Box>
      );
    },
  },
];

export const UsersSupervisionDatatableMeta = {
  columns,
};
